<div class="socialList">
  @for (social of socialList(); track social.provider) {
    <div class="social">
      @if (social.status) {
        <div>
          <img
            [src]="
                    'assets/images/socials/' + social.provider + '-Logo.png'
                  "
            alt=""
            class="social-img"
          />
          <div class="social-id">{{ social.client_id }}</div>
        </div>
        <button
          class="btn"
          (click)="deleteSocial(social.id!, social.provider)"
        >
          <icon-trash></icon-trash>
        </button>
      } @else {
        <button class="noAccount" (click)="linkSocial(social.provider)">
          <img
            [src]="
                    'assets/images/socials/' + social.provider + '-Logo.png'
                  "
            alt=""
            class="social-img"
          />
          <div>
            {{ "profilePage.link" | translate }} {{ social.provider }}
          </div>
        </button>
      }
    </div>
  }
</div>
